/* global window */
/* eslint no-use-before-define: ["error", { "functions": false }], no-restricted-globals: 1 */
import iframeBridge from './iframe-bridge';

/**
 * Determines whether the app bridge is set in the global scope
 * and attaches click events when this is the case
 *
 * @param {HTMLNode} rootElement The element to attach events to
 * @return {Boolean}
 */
export default function(rootElement) {
  const root = iframeBridge.getRoot(window);
  if (!isAppEnabled(root, rootElement)) {
    return false;
  }

  appModalClickHandler(root, rootElement);

  return true;
}

/**
 * Determines whether SKY_SPORTS_APP, appWrapper or AndroidApp
 * is present in the global scope
 *
 * @param {Object} root The window object to assess
 * @return {Boolean}
 */
function isAppEnabled(root) {
  if (isSkySportsApp(root) || isAndroidApp(root)) {
    return true;
  }

  if (isAppWrapper(root)) {
    return true;
  }

  return false;
}

/**
 * Determines whether SKY_SPORTS_APP is present
 * in the global scope
 *
 * @param {Object} root The window object to assess
 * @return {Boolean}
 */
function isSkySportsApp(root) {
  if (typeof root.SKY_SPORTS_APP !== 'undefined') {
    return true;
  }

  return false;
}

/**
 * Determines whether appWrapper is present
 * in the global scope
 *
 * @param {Object} root The window object to assess
 * @return {Boolean}
 */
function isAppWrapper(root) {
  if ((typeof root.appWrapper !== 'undefined') &&
      root.appWrapper.app) {
    return true;
  }

  return false;
}

/**
 * Determines whether AndroidApp is present
 * in the global scope
 *
 * @param {Object} root The window object to assess
 * @return {Boolean}
 */
function isAndroidApp(root) {
  if (typeof root.AndroidApp !== 'undefined') {
    return true;
  }

  return false;
}

/**
 * Attaches event to the passed element to trigger the modal
 * to open in the app when the element is clicked
 *
 * @param {Object} root The window object to assess
 * @param {HTMLNode} rootElement The element to attach the event to
 */
function appModalClickHandler(root, rootElement) {
  event.stopPropagation();

  /*
    * ⚠️ README BEFORE MAKING CHANGES TO THE BRIDGE CALLS
    * The following signatures should not be changed without
    * consulting with the iOS and Android app developers.
    * Please see the App Bridge section in the component README
    */
  if (isSkySportsApp(root)) {
    root.SKY_SPORTS_APP.modal.create(
      getChannelId(rootElement),
      getChannelTitle(rootElement),
      getCompetitionId(rootElement),
      getHomeTeam(rootElement),
      getAwayTeam(rootElement)
    );
  }

  if (isAppWrapper(root)) {
    if (root.appWrapper) {
      root.appWrapper.app.modal.create(
        getChannelId(rootElement),
        getChannelTitle(rootElement),
        getCompetitionId(rootElement),
        getHomeTeam(rootElement),
        getAwayTeam(rootElement)
      );
    }
  }

  if (isAndroidApp(root)) {
    if (root.AndroidApp) {
      root.AndroidApp.createModal(
        getChannelId(rootElement),
        getChannelTitle(rootElement),
        getCompetitionId(rootElement),
        getHomeTeam(rootElement),
        getAwayTeam(rootElement)
      );
    }
  }
}

/**
 * Returns the Channel Id value
 *
 * @param {HTMLNode} rootElement The element to get the data from
 * @return {String}
 */
function getChannelId(rootElement) {
  return rootElement.getAttribute('data-channel-id');
}

function getChannelTitle(rootElement) {
  return rootElement.getAttribute('data-channel-title');
}

function getCompetitionId(rootElement) {
  return rootElement.getAttribute('data-competition-id');
}

function getHomeTeam(rootElement) {
  return rootElement.getAttribute('data-home-team');
}

function getAwayTeam(rootElement) {
  return rootElement.getAttribute('data-away-team');
}
